import React, { Fragment } from 'react';
import { string } from 'prop-types';
import Head from 'next/head';
import { DOMParser } from 'util/dom';
import styles from './styles';

function AmpCuralateEmbed({ raw }) {
  const parser = new DOMParser();
  const doc = parser.parseFromString(raw, 'text/html');
  let src;
  let width;
  let height;
  if (doc) {
    const iframe = doc.getElementsByTagName('iframe')[0];
    src = iframe.getAttribute('src');
    width = iframe.getAttribute('width');
    height = iframe.getAttribute('height');
  }
  return (
    <Fragment>
      <style jsx>{styles}</style>
      <Head>
        <script
          async
          custom-element="amp-iframe"
          key="amp-iframe"
          src="https://cdn.ampproject.org/v0/amp-iframe-0.1.js"
        />
      </Head>
      <amp-iframe
        className="CuralateEmbed"
        src={src}
        layout="responsive"
        width={width}
        height={height}
        sandbox="allow-scripts allow-same-origin allow-popups"
      >
        <amp-img
          layout="fill"
          src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
          placeholder
        />
      </amp-iframe>
    </Fragment>
  );
}

AmpCuralateEmbed.propTypes = {
  raw: string
};

AmpCuralateEmbed.defaultProps = {
  raw: null
};

export default AmpCuralateEmbed;
